<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="add-engineering">
            <van-nav-bar title="上传工程进度" left-text="工程进度" right-text="保存" left-arrow @click-left="swiperright" @click-right="onSave"></van-nav-bar>
            <section>
                <div class="input-wrapper">
                    <p><i class="iconfont iconbeizhu"></i></p>
                    <van-field v-model="visual_progress" rows="3" autosize type="textarea" maxlength="50" placeholder="请输入留言" show-word-limit></van-field>
                </div>
                <div class="img-wrapper">
                    <van-uploader v-model="fileList" multiple :before-read="uploadFileBefore" :after-read="uploadFileMethod" @delete="deleteFile">
                        <div class="upload-wrapper">
                            <i class="iconfont iconicon-test"></i>
                        </div>
                    </van-uploader>
                </div>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';
import { Toast } from 'vant';
export default {
    mixins: [mixin_fileUpload],
    data() {
        return {
            visual_progress: '', // 添加工程进度填写的描述
            images_data: [], // 保存时图片的集合
            fileList: [], // 图片上传成功的集合
            active: '', // 上一个页面带过来的tab索引
            detail: {}, // 上一个页面带过来的合同基本信息
            fileDataId: '',
        };
    },
    created() {
        this.active = this.$route.params.active; // 上一个页面带过来的tab索引
        this.detail = this.$route.params.obj; // 上一个页面带过来的合同基本信息
        this.fileDataId = this.detail.engineering_id;
    },
    mounted() {},
    methods: {
        // 删除图片的回调
        deleteFile(file, row) {
            this.images_data.splice(row.index, 1);
        },
        // 上传的回调
        callBackFun(res) {
            if (res && res.FileID) {
                this.images_data.push(res.FileID);
            }
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'schedule', params: { obj: this.detail, active: this.active } });
            this.$router.go(-1);
        },
        // 保存工程进度
        onSave() {
            Toast.loading({
                message: '请求中...',
                forbidClick: false,
                loadingType: 'spinner',
            });
            this.$axios
                .post('/interfaceApi/sale/engineering_progress/add_engineering', {
                    engineering_id: this.detail.engineering_id,
                    visual_progress: this.visual_progress,
                    images_data: this.images_data.join(','),
                })
                .then(() => {
                    Toast.success({
                        message: '保存成功',
                        duration: 500,
                    });
                    setTimeout(() => {
                        this.$router.isBack = 1;
                        this.$router.replace({ name: 'schedule', params: { obj: this.detail, active: this.active } });
                        this.$router.go(-1);
                    }, 1000);
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>

<style lang="stylus">
    .add-engineering
        width 100%
        height 100%
        section
            height calc(100% - 45rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            background #ffffff
            padding 15rpx
            .input-wrapper
                padding 10rpx
                // height 130rpx
                border 1px solid rgba(215,215,215,1)
                border-radius 4rpx
                display flex
                // background #ffffff
                .van-cell
                    padding-top 0
            .img-wrapper
                padding 15rpx 0
                .van-uploader__wrapper
                    .van-uploader__preview
                        width 75rpx
                        height 75rpx
                        border 1px solid rgba(215,215,215,1)
                        border-radius 4rpx
                        margin 0 10px 10px 0
                        img
                            width 73rpx
                            height 73rpx
                .upload-wrapper
                    width 75rpx
                    height 75rpx
                    border 1px solid rgba(215,215,215,1)
                    border-radius 4rpx
                    line-height 75rpx
                    text-align center

</style>
